import './LoginPage.css';   
import { useState } from 'react';
import { Container, Card, Form, Button,FloatingLabel,InputGroup } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye,faEyeSlash,faUser, faLock, faCheck } from '@fortawesome/free-solid-svg-icons'; // Import specific icons here
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

library.add(
  faUser,
  faLock,
  faCheck,
  faEye,
  faEyeSlash
);

const elegantColor = '#4a4e69';



function LoginPage({ onLoginSuccess }) {

 

    const ConfirmUserExistsJSON = () => { 
      try {  
              axios.get(window.config.API_URL_BO+"User/ConfirmUserExists/" +document.getElementById("username").value +"/"+ document.getElementById("password").value , { 
              })
              .then(response => {   
                   onLoginSuccess(response.data.AccountId,response.data.isAdmin); 
                   if (response.data.isAdmin){
                      navigate('/results');
                   }else{
                      navigate('/results');
                   } 
              })
              .catch(error => {
                 document.getElementById("responsevali").style.visibility = 'visible';
              });  
      } catch (err) {
        document.getElementById("responsevali").style.visibility = 'visible';
      } finally {  
      }  
  };

  const buildConfirmUserExists = () => { 
    const xml = `
      <ConfirmUserExistsRQ xsi:schemaLocation="NetSemanticsSA_CRM ConfirmUserExistsRQ.xsd" EchoToken="" xmlns="NetSemanticsSA_CRM" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
        <POS>
          <Source>
            <RequestorID ID="${document.getElementById("username").value}" MessagePassword="${document.getElementById("password").value}" />
          </Source>
        </POS>
        <LoginInformation>
          <Login UserName="${document.getElementById("username").value}" UserPassword="${document.getElementById("password").value}" IsSupplier="false" />
        </LoginInformation>
        <TPA_Extensions>
          <BackofficeRequest>true</BackofficeRequest>
        </TPA_Extensions>  
      </ConfirmUserExistsRQ> 
    `;
    return xml.trim(); 
  };
  
  const ConfirmUserExistsXML = () => { 
    const  ConfirmUserExists = buildConfirmUserExists(); 
    const xhr = new XMLHttpRequest();
    const url = window.config.API_URL_BO; 
    xhr.open('POST', url, true);  
    xhr.setRequestHeader('Content-Type', 'text/xml');
 
    xhr.onload = function () { 
      if (xhr.status >= 200 && xhr.status < 300) { 
        const xmlString = xhr.responseText;
      
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
        const resultElement = xmlDoc.getElementsByTagName('UserInfo')[0];
        const AccountID = resultElement ? resultElement.getAttribute('AccountID') : '';
        const isAdmin = resultElement ? resultElement.getAttribute('isAdmin') : '';
        const UserType = resultElement ? resultElement.getAttribute('UserType') : '';

        if (AccountID.length === 0 || isAdmin.length === 0){
              document.getElementById("responsevali").style.visibility = 'visible';
        }else{
              if (UserType==='10'){
                    onLoginSuccess(AccountID,isAdmin); 
                    if (isAdmin){
                          navigate('/results');
                    }else{
                          navigate('/results');
                    }
                    
              }else{
                    document.getElementById("responsevali").style.visibility = 'visible';
              } 
        } 
      } else { 
        alert(`Error! Status: ${xhr.status}. Response: ${xhr.responseText}`);
      }
    };
  
    xhr.send(ConfirmUserExists);  
  };

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false); 
   
  const [formData, setFormData] = useState({ username: '', password: '' });

  const icon = showPassword ? 'eye-slash' : 'eye';

  const togglePasswordVisibility = () => {
    setShowPassword(prevShowPassword => !prevShowPassword);
  };

  const passwordchange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
    document.getElementById("passwordvalid").style.visibility = 'hidden';
    document.getElementById("responsevali").style.visibility = 'hidden';
  };
  
  const usernamechange = (e) => {
      document.getElementById("usernamevalid").style.visibility = 'hidden';    
      document.getElementById("responsevali").style.visibility = 'hidden';
  }; 

  const handleSubmit = (event) => {
    event.preventDefault(); 
    let itsok = true;
    if(document.getElementById("username").value.length === 0){
      itsok=false;
      document.getElementById("usernamevalid").style.visibility = 'visible';
    }
    if(document.getElementById("password").value.length === 0){
      itsok=false;
      document.getElementById("passwordvalid").style.visibility = 'visible';
    }
    if(itsok){
      if(window.config.isXMLAPI){
            ConfirmUserExistsXML();
      }else{
            ConfirmUserExistsJSON();
      }
       
    } 
  };


  return (
     <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      
       <Card style={{ width: '100%', maxWidth: '400px', padding: '20px' }}>
        <Card.Body>
          
          <h4 
            className="text-center fw-semibold mb-4 pb-3 border-bottom"
            style={{ color: elegantColor, letterSpacing: '1px' }}  
          >
            Assignment Webform Login
          </h4> 
          <Form onSubmit={handleSubmit}>
                   
            <FloatingLabel 
              label={<><FontAwesomeIcon icon="user" className="me-2" />Username</>} 
            > 
              <Form.Control id="username" type="text" placeholder="Username" onChange={usernamechange} />
            </FloatingLabel>
            <div className='textleft'> <span id='usernamevalid' className='usernamevalid' >Please insert username</span></div>
            <InputGroup>
              <FloatingLabel   label={<><FontAwesomeIcon icon="lock" className="me-2" />Password</>}>
                <Form.Control  
                  type={showPassword ? 'text' : 'password'} 
                  placeholder="Password" 
                  id="password"
                  value={formData.password}
                  onChange={passwordchange}
                />
              </FloatingLabel>
               
              <Button 
                variant="outline-secondary" 
                onClick={togglePasswordVisibility} 
                style={{ borderColor: '#e0e0e0', zIndex: 3 }} 
              >
                <FontAwesomeIcon icon={icon} />
              </Button>
            </InputGroup>
            <div className='textleft'><span id='passwordvalid' className='passwordvalid'>Please insert password</span></div>
            <div className="d-grid gap-2">
              <Button variant="primary" type="submit" size="lg">
                Login
              </Button>
            </div>
            <div><span id='responsevali' className='responsevali' >Username or password is incorrect. Please try again!</span></div>
          </Form>
        </Card.Body>
      </Card>

     
    </Container>
  );
}

export default LoginPage;
